import * as React from "react";
import styled from "styled-components";
import Text from "../Text";
import { IconName } from "../Icon";
import IconButton from "../IconButton";
import { select } from "@hubper/theme";

const Base = styled.div`
  display: flex;
  align-items: center;
  padding: ${select.space(2)};
  border-top: 1px solid ${select.color(["grey", 1])};
  transition: ${select.speed("fast")};
  &:last-child {
    border-bottom: 1px solid ${select.color(["grey", 1])};
  }

  &:hover {
    background-color: ${select.color(["grey", 0])};
  }
`;

type Props = {
  style?: React.CSSProperties;
  className?: string;
  title: string;
  value: string;
  disabled?: boolean;
  icon: IconName;
  onClick?: (value: string) => void;
  onIconClick: (value: string) => void;
};

function IconListItem(
  {
    style,
    className,
    title,
    value,
    icon,
    onIconClick,
    onClick,
    disabled
  }: Props,
  ref: any
) {
  return (
    <Base
      ref={ref}
      style={style}
      className={className}
      onClick={() => (onClick ? onClick(value) : null)}
    >
      <Text c={["grey", 7]} fs={-1} style={{ flexGrow: 1 }}>
        {title}
      </Text>
      <IconButton
        name={icon}
        onClick={() => onIconClick(value)}
        disabled={disabled}
      />
    </Base>
  );
}

export default React.forwardRef(IconListItem);
